import { useMemo, useState } from "react";

const IMAGES = [
  {
    id: 1,
    category: "Bridal",
    title: "The Quiet Bride",
    src: "https://images.pexels.com/photos/34955448/pexels-photo-34955448.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    span: "md:col-span-6 md:row-span-2",
    aspect: "aspect-[3/4]",
  },
  {
    id: 2,
    category: "Editorial",
    title: "Aurelia",
    src: "https://images.pexels.com/photos/33976561/pexels-photo-33976561.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=900",
    span: "md:col-span-6",
    aspect: "aspect-[4/3]",
  },
  {
    id: 3,
    category: "Natural",
    title: "Morning Light",
    src: "https://images.unsplash.com/photo-1674932668403-33398b81c92f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxuYXR1cmFsJTIwbWFrZXVwJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgwNjc1NjEzfDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-3",
    aspect: "aspect-square",
  },
  {
    id: 4,
    category: "Party",
    title: "Evening No. 04",
    src: "https://images.pexels.com/photos/14943052/pexels-photo-14943052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    span: "md:col-span-3",
    aspect: "aspect-square",
  },
  {
    id: 5,
    category: "Bridal",
    title: "Linen & Lace",
    src: "https://images.unsplash.com/photo-1600685890506-593fdf55949b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxicmlkYWwlMjBtYWtldXAlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA2NzU2MTN8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    id: 6,
    category: "Editorial",
    title: "Carmine",
    src: "https://images.unsplash.com/photo-1557924760-b14a6d4a4ef3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBtYWtldXAlMjBmYXNoaW9ufGVufDB8fHx8MTc4MDY3NTYxM3ww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    id: 7,
    category: "Natural",
    title: "Glow Study",
    src: "https://images.pexels.com/photos/10469305/pexels-photo-10469305.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    span: "md:col-span-4",
    aspect: "aspect-[3/4]",
  },
];

const FILTERS = ["All", "Bridal", "Editorial", "Party", "Natural"];

export default function Portfolio() {
  const [active, setActive] = useState("All");

  const visible = useMemo(
    () => (active === "All" ? IMAGES : IMAGES.filter((i) => i.category === active)),
    [active]
  );

  return (
    <section id="portfolio" data-testid="portfolio-section" className="py-24 md:py-36 bg-melissa-bg">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <p className="text-xs uppercase tracking-overline text-melissa-rose mb-6">
              03 — Selected Work
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-melissa-ink leading-tight tracking-tight max-w-2xl">
              A small archive of faces and <em className="italic text-melissa-rose">moments.</em>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`portfolio-filter-${f.toLowerCase()}`}
                onClick={() => setActive(f)}
                className={`px-4 py-2 text-[10px] uppercase tracking-overline border transition-colors duration-300 ${
                  active === f
                    ? "bg-melissa-ink text-melissa-bg border-melissa-ink"
                    : "bg-transparent text-melissa-ink border-melissa-border hover:border-melissa-ink"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 auto-rows-[260px] md:auto-rows-[320px]">
          {visible.map((img) => (
            <figure
              key={img.id}
              data-testid={`portfolio-item-${img.id}`}
              className={`${img.span} ${img.aspect} relative overflow-hidden group cursor-pointer`}
            >
              <img
                src={img.src}
                alt={img.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-melissa-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-4 left-4 right-4 text-melissa-bg opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <p className="text-[10px] uppercase tracking-overline">{img.category}</p>
                <p className="font-serif text-xl mt-1">{img.title}</p>
              </figcaption>
            </figure>
          ))}
        </div>

        {visible.length === 0 && (
          <div data-testid="portfolio-empty" className="text-center text-melissa-inkSoft text-sm py-16">
            No work in this category yet.
          </div>
        )}
      </div>
    </section>
  );
}
